<template>
  <div v-wechat-title="$route.meta.title='活动列表'">
     <van-nav-bar
            title="视频列表"
            left-text="返回"
            left-arrow
            @click-left="onClickLeft"
          />
  <van-pull-refresh style="min-height: 100vh;"  v-model="isLoading" @refresh="onRefresh">
    <van-list
      v-model="loading"
      :finished="finished"
      :offset="1"
      finished-text="没有更多了"
      @load="onLoad"
    >
     
        <div  class="demo-lazyload" v-for="(item,index) in list">
            <div @click="videoDetail(item.id)" class="activity"  :style="{backgroundImage:'url('+item.img+')'}">
            	
                <div class="news_r" >
                    <p>{{item.title}}</p>
                </div>
            </div>
  		</div>
     </van-list>
</van-pull-refresh>
</div>
</template>
<script>
import { getVideoList } from '@/api/api.js'
export default {
    components: {
       
    },
    data(){
        return{
            aid:0,//产品id
            list:[],
            page:1,//页码,默认为1
            pageNum:10,//每页数量
            page_count:1,//总页数,初始为1 
            isLoading: false ,//下拉刷新
            loading: false,
            finished: false,
            aid:0
        }
    },
    beforeMount() {
        
    },
    mounted() {
        this.getParams();
    },
    methods: {
        //下拉刷新
           onRefresh() {
              this.page = 1;
              this.list = [];

              this.onLoad();
              setTimeout(() => {
                this.$toast('刷新成功');
                this.isLoading = false;
                this.finished = false;
              }, 500);
            },
            //下拉加载10
             onLoad() {
              if(this.page>this.page_count){
                    this.finished = true;
                    this.loading = false;
                    return ;
                }
              // 异步更新数据
                let parame = {'aid':this.aid,'page':this.page,'pageNum':this.pageNum};
                getVideoList(parame).then((res)=>{
                    if(res.code==200){
                        if (res.result.list.length > 0) {//没有数据
                            if(this.list.length==0){
                                    this.list = res.result.list;

                            }else{
                                this.list = this.list.concat(res.result.list)
                                
                            }
                            this.page_count = res.result.page_count;
                            this.page++;
                             // 加载状态结束
                            this.loading = false;
                           
                        }else{
                             // 数据全部加载完成
                            this.finished = true;
                            this.loading = false;
                        }  
                    } 
                   //Toast('提示内容')
                  //console.log(this.list);  
                }),(err)=>{
                    console.log(err);
                }
                          
              
         },
        getParams() {
            this.aid = this.$route.query.aid;
        },
        //返回上一页
        onClickLeft(){
            this.$router.go(-1)
        },

    	//视频列表
    	videoDetail(id){
    	   
    			this.$router.push({name:'videoDetail',query:{id:id}})	
    	
    	}	
       
    }
}
</script>
<style  scoped>
.demo-lazyload {
	    box-sizing: border-box;
	    height: 200px;
	    margin: 10px;
	    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}
.activity{
	height: 100%;
    width: 100%;
    background-color: white;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    position:relative;
    margin-bottom: .6rem;
}
.news_r{
	position: absolute;
    bottom: 0;
    width: 100%;
    color: white;
    background-color: #323233;
    opacity: .8;
}


</style>
